import { getEnvironment } from '../../../../core/env/environment';
import { useQueryGetRegistrationPageOptional } from '../../../registration-pages/queries';

export interface OpenRegistrationPageProps {
  projectId: string;
  registrationPageId: string;
  onDone?: () => void;
}

export function OpenRegistrationPage({ projectId, registrationPageId, onDone }: OpenRegistrationPageProps) {
  const registrationPage = useQueryGetRegistrationPageOptional(projectId, registrationPageId);

  if (!registrationPage.data || registrationPage.isLoading) {
    return null;
  }

  const registrationPageUrl = `${getEnvironment().registrationPagesUrl}/${registrationPage.data.data?.urlSlug}`;
  window.open(registrationPageUrl);
  onDone?.();
  return null;
}
